import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect() {
    this.toggleSubmit()
  }

  toggleSubmit() {
    if (!this.hasSubmitTarget) return

    const checkboxes = this.checkboxTargets

    if (checkboxes.length === 0) {
      this.submitTarget.disabled = false
      return
    }

    const allChecked = checkboxes.every(checkbox => checkbox.checked)
    this.submitTarget.disabled = !allChecked
  }
}
